import Meta from '@components/article/Meta'
import { urlFor } from '@lib/sanity'
import Image from 'next/image'

import styles from './Author.module.scss'

export default function Author({ data }) {
  const { author } = data
  const { authorName, authorPhoto } = author[0] || {}

  return (
    <section className={styles.wrapper}>
      <div className={styles.avatar}>
        <Image
          src={urlFor(authorPhoto.asset)
            .quality(85)
            .crop('focalpoint')
            .fit('crop')
            .format('webp')
            .width(200)
            .height(200)
            .url()}
          alt={authorName}
          fill
          sizes="(max-width: 200px) 100vw, 200px"
        />
      </div>
      <div className={styles.details}>
        <p className="mb-2">Written by {authorName}</p>

        <Meta data={data} hAlign={'row'} vAlign={'left'} />
      </div>
    </section>
  )
}
